import React from "react";
import { AlertTriangle } from "lucide-react";
import "./index.css";

interface ErrorScreenProps {
  onRetry: () => void;
  errorMessage?: any;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ onRetry, errorMessage }) => {
  return (
    <div className="error-screen">
      <AlertTriangle className="error-icon" />
      <div className="error-title">Error loading allocations</div>
      <p className="error-message">
        {errorMessage || "Please try again or contact support if the problem persists"}
      </p>
      <button className="error-retry-button" onClick={onRetry}>
        Retry
      </button>
    </div>
  );
};

export default ErrorScreen;